import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import MaintenanceGate from './MaintenanceGate';
import { useLocation } from 'react-router-dom';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './Redux/Store';
import { ThemeProvider } from '@emotion/react';
import Theme from './RendezvousOnTheRed/Theme';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

const router = createBrowserRouter([
  {
    path: '/*',
    element: <App />,
  },
]);

function Availability() {
const { pathname } = useLocation();
const siteCode = 'rotr';
return <MaintenanceGate siteCode={siteCode} statusUrl={'https://hub.sportssouth.app/api/maintenance/' + siteCode + '/status'} loginPath={null} pathname={pathname} ><App /></MaintenanceGate>;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={Theme}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <RouterProvider router={router} />
        </PersistGate>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);
